import { render, staticRenderFns } from "./SectionTalentPower.vue?vue&type=template&id=ec799810&scoped=true"
import script from "./SectionTalentPower.vue?vue&type=script&lang=js"
export * from "./SectionTalentPower.vue?vue&type=script&lang=js"
import style0 from "./SectionTalentPower.vue?vue&type=style&index=0&id=ec799810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec799810",
  null
  
)

export default component.exports